export const FETCH_ANSWERS = "FETCH_ANSWERS";
export const FETCH_ANSWERS_FAILURE = "FETCH_ANSWERS_FAILURE";
export const FETCH_ANSWERS_SUCCESS = "FETCH_ANSWERS_SUCCESS";
export const FETCH_QUESTION = "FETCH_QUESTION";
export const FETCH_QUESTION_FAILURE = "FETCH_QUESTION_FAILURE";
export const FETCH_QUESTION_SUCCESS = "FETCH_QUESTION_SUCCESS";
